import {priority} from '@priority-software/priority-proto-api/lib';
import {FormDesignData} from '../../Form/Form';

export const getNonEmptyTabs = (tabs: priority.netitems.form.IRowViewTabsDesign[]) => {
    return tabs.filter(tab => tab.ColumnsDesign.length > 0);
};

export const createDefaultDesign = (data: FormDesignData) => {
    return {
        showPicture: data.showPicture ?? false,
        tableViewColumnsDesign: data.tableViewColumnsDesign ?? [],
        rowViewColumnsDesign: getNonEmptyTabs(data.rowViewColumnsDesign ?? []),
        actionsDesign: data.actionsDesign ?? [],
        subformsDesign: data.subformsDesign ?? []
    };
};
